define('lq/events/actions/azureAIBatchCommand',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function AzureAIBatchCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        return this;
    }

    EventAction.extend(AzureAIBatchCommand, EventAction);

    AzureAIBatchCommand.typeName = 'AzureAIBatchCommand';

    AzureAIBatchCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    AzureAIBatchCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'AzureAIBatch',
            command: this.eventData.command
        };
    };

    return AzureAIBatchCommand;
});

